import { notEmpty } from "@product/scmp-sdk";
import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { useEffect } from "react";

import { appAtom } from "scmp-app/lib/app/atoms";
import type { Edition } from "scmp-app/lib/edition";
import { editionOptions, editions } from "scmp-app/lib/edition/data";

import {
  EditionGroup,
  EditionText,
  StyledBaseLink,
  StyledNotificationItem,
  Text,
  UnknownGeoContainer,
  YesButtonLink,
} from "./styles";

export type Props = {
  editionFromRoute: Edition;
  onClose?: () => void;
  onEditionSet: (key?: Edition) => void;
  suggestEdition: Edition;
};

export const EditionInvitation: FunctionComponent<Props> = ({
  editionFromRoute,
  onClose,
  onEditionSet,
  suggestEdition,
}) => {
  const { ipGeoLocation } = useAtomValue(appAtom);
  const isUnknownLocation = !notEmpty(ipGeoLocation?.result?.country);

  // Set the edition when it's shown
  useEffect(() => {
    onEditionSet(editionFromRoute);
  }, [editionFromRoute, onEditionSet]);

  const renderContent = () => {
    if (isUnknownLocation)
      return (
        <UnknownGeoContainer>
          <Text>Please select your preferred edition:</Text>
          <EditionGroup>
            {editionOptions.map(edition => (
              <StyledBaseLink
                key={edition.value}
                onClick={() => {
                  onEditionSet(edition.value);
                  onClose?.();
                }}
                pathname={edition.href}
              >
                {edition.label}
              </StyledBaseLink>
            ))}
          </EditionGroup>
        </UnknownGeoContainer>
      );
    return (
      <>
        <Text>
          {"Would you like to switch to the "}
          <EditionText>{editions[suggestEdition].label}</EditionText>
          {" edition?"}
        </Text>
        <YesButtonLink
          onClick={() => {
            onEditionSet();
            onClose?.();
          }}
          pathname={editions[suggestEdition].href}
        >
          YES
        </YesButtonLink>
      </>
    );
  };

  return (
    <StyledNotificationItem
      onClose={() => {
        onEditionSet(editionFromRoute);
        onClose?.();
      }}
    >
      {renderContent()}
    </StyledNotificationItem>
  );
};

EditionInvitation.displayName = "EditionInvitation";
